import { navigate } from '@reach/router'
import React, { useEffect } from 'react'
import { TemplateProps } from '../../../journeys/journey/Interfaces';
import { Typography } from "@material-ui/core";
import { Button, Cards, CustomIcon } from 'ams-ui-reactkit';
import './moveWithUs.scss'
import useCommon from "../common/useCommon"
import { getCustomerId, getDailysheetId } from '../../../utils/Utils';
import DynamicHtml from "../../../molecules/DynamicHtml"

const MoveWithUs: React.FC<TemplateProps> = (props: any) => {
    const { updateBolStatus } = useCommon();
    const { templateProps } = props
    const { script, content, footerText } = templateProps

    useEffect(() => {
        updateBolStatus(getCustomerId(), getDailysheetId(), "DRAFT")
    }, [])

    const handleSubmit = async () => {
        navigate(templateProps?.nextScreen || '/')
    }
    return (
        <div className="baseContainerBlock movewithUsBlock">
            {script && <Cards variant="primary">
                <div className="thankyoumainblock">
                    <div >
                        <CustomIcon iconName="letsgetmoving" />
                    </div>
                    <Typography variant="body1" component="span" className="thankyoudesc">
                        <DynamicHtml content={script} />
                    </Typography>
                </div>
            </Cards>}
            {<div className="fullBlock sm-mb-50"><Cards variant="default">
                <div className="thankyoumainblock">
                    <div className="fullBlock">
                        <Typography variant="subtitle2" component="span" className="introdesc">
                            <DynamicHtml content={content.primaryText} />
                        </Typography>
                    </div>

                    <div className="fullBlock introimg">
                        <CustomIcon iconName="estimateicon" />
                    </div>
                    <div className="fullBlock">
                        <Typography variant="subtitle2" component="span" className="introdesc">
                            <DynamicHtml content={content.secondaryText} />
                        </Typography>
                    </div>

                </div>

            </Cards></div>}

            <div className="fullBlock stickeyBlock">
                <Typography variant="subtitle2" component="div" className="footerStickey">
                    <DynamicHtml content={footerText} />
                </Typography>
            </div>

            <div className="staticFixedButton">

                <Button
                    text={templateProps?.button}
                    onClick={handleSubmit}
                    color="primary"
                    variant="contained"
                    size="large"
                    disabled={getCustomerId() ? false : true}
                />
            </div>
        </div>
    )
}

export default MoveWithUs
